const problemas = {
  manchas: document.querySelector("#shopify-section-template--25173832368456__featured_collection_ByKmHm"),
  luminosidad: document.querySelector("#shopify-section-template--25173832368456__featured_collection_PURfep"),
  arrugas: document.querySelector("#shopify-section-template--25173832368456__featured_collection_eDaG7m"),
  flacidez: document.querySelector("#shopify-section-template--25173832368456__featured_collection_4RxF34"),
  ojeras: document.querySelector("#shopify-section-template--25173832368456__featured_collection_7PzBRU")
};

const bloqueSensible = document.querySelector("#shopify-section-template--25173832368456__rich_text_8qh4MR");

const url_results = document.URL;
const queryString = url_results.split("?")[1];
const params = new URLSearchParams(queryString);
const tipo_piel_param = params.get("tipo_piel");
const problema_param = params.get("problema");

const esPielSensible = tipo_piel_param == "sensible";

if (bloqueSensible) {
  bloqueSensible.style.display = esPielSensible ? "" : "none";
}

if (esPielSensible) {
  Object.values(problemas).forEach((section) => {
    if (section) section.style.display = "none";
  });
} else if (problema_param) {
  const problemasSeleccionados = problema_param
    .split(",")
    .map((p) => p.trim())
    .filter(Boolean);

  Object.entries(problemas).forEach(([key, section]) => {
    if (section) {
      section.style.display = problemasSeleccionados.includes(key) ? "" : "none";
    }
  });
}